"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.citizenLoginSchema = exports.notifyLoginSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const US_PHONE_NUMBER_WITHOUT_SPECIAL_CHARCTER_AND_WITH_COUNTRY_CODE_REGEX = /^1\s*(?:[.-]\s*)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})$/;
exports.notifyLoginSchema = yup_lib_1.default.object().shape({
    email: yup_lib_1.default.string().email().required().max(320).label('Email'),
    code: yup_lib_1.default
        .string()
        .nullable()
        .matches(/^\d{6}$/, 'OTP must be exactly 6 numeric digits')
        .notRequired()
});
exports.citizenLoginSchema = yup_lib_1.default.object().shape({
    phoneNumber: yup_lib_1.default
        .string()
        .required()
        .matches(US_PHONE_NUMBER_WITHOUT_SPECIAL_CHARCTER_AND_WITH_COUNTRY_CODE_REGEX, 'Phone number must be a valid US phone number with country code, e.g., 1234567890')
        .label('Phone Number'),
    code: yup_lib_1.default
        .string()
        .nullable()
        .matches(/^\d{6}$/, 'OTP must be exactly 6 numeric digits')
        .notRequired()
});
